import React, { useRef } from "react";
import { useEffect, useState } from "react";
import "../styles.css";
import ContantLoader from "../ContantLoader";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  getAllEmailTemplatesTheme,
  getAllBlogTemplatesTheme,
  getAllCalculatorTemplatesTheme,
  getAllTemplatesCount,
  getAllOffers,
  addToCartTemplate,
  getTemplateTags,
  getAllTemplatesCountByTag
} from "api/TemaplateApi";
import {
  setTemplateParameterId,
  setTemplateId,
  setIsContentFlag,
  setBaseTemplateId,
  setCurrentTab,
} from "ReduxStore/Slices/templateSlice";
import { useDispatch, useSelector } from "react-redux";
import { setTemplateType, setISOffer } from "ReduxStore/Slices/templateSlice";
import { NoEncryption } from "@material-ui/icons";
import { toast } from "react-toastify";
import { getPermissions } from 'api/UsersApi'
import SupportLink from "../Common/SupportLink";


const Content = (props) => {
  const [getLayoutTemplate, setLayoutTemplate] = useState();
  const [getSystemtTemplate, setSystemTemplate] = useState();
  const [getUserTemplate, setUserTemplate] = useState();
  const [offers, setOffers] = useState();
  const [e_type, sete_type] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [getTemplateid, setTemplateid] = useState({ t_id: "" });
  const [nextLayoutButton, setNextLayoutButton] = useState(1);
  const [offSet, setOffSet] = useState(0);
  const [matchNextButton, setMatchNextButton] = useState(1);
  const [nextButton, setNextButton] = useState(1);
  const [offSetB, setOffSetB] = useState(0);
  const [matchNextButtonB, setMatchNextButtonB] = useState(1);
  const [nextButtonB, setNextButtonB] = useState(1);
  const [offSetE, setOffSetE] = useState(0);
  const [matchNextButtonE, setMatchNextButtonE] = useState(1);
  const [nextButtonE, setNextButtonE] = useState(1);
  const dispatch = useDispatch();
  const PER_PAGE = 8;
  const [matchNextButtonO, setMatchNextButtonO] = useState(1);
  const [nextButtonO, setNextButtonO] = useState(1);
  const [offSetO, setOffSetO] = useState(0);
  const [blogTemplateTags, setBlogTemplateTags] = useState([]);

  const [checkoutPermission, setCheckoutPermission] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);


  const emailNavRef = useRef();
  const calculatorNavRef = useRef();
  const blogNavRef = useRef();
  const offerNavRef = useRef();
  const emailTabRef = useRef();
  const calculatorTabRef = useRef();
  const blogTabRef = useRef();
  const offerTabRef = useRef();
  const permissionMessageRef = useRef();

  const { role } = useSelector(
    (state) => state.userSetter
  );


  const { currentTab } = useSelector((state) => state.templateSetter);
  const getTotalCount = () => {
    getAllTemplatesCount()
      .then((data) => {
        setTotalCount(data);
        setNextButton(() => Math.floor(data.calculatorCount / PER_PAGE));
        if (data.calculatorCount == PER_PAGE) {
          setNextButton(Math.floor(data.calculatorCount / PER_PAGE) - 1);
        }
        setNextButtonB(() => Math.floor(data.blogCount / PER_PAGE));
        if (data.blogCount == PER_PAGE) {
          setNextButtonB(Math.floor(data.blogCount / PER_PAGE) - 1);
        }
        setNextButtonE(() => Math.floor(data.emailThemeCount / PER_PAGE));
        if (data.emailThemeCount == PER_PAGE) {
          setNextButtonE(Math.floor(data.emailThemeCount / PER_PAGE) - 1);
        }
        setNextLayoutButton(() => Math.floor(data.layoutCount / PER_PAGE));
        if (data.layoutCount == PER_PAGE) {
          setNextLayoutButton(Math.floor(data.layoutCount / PER_PAGE) - 1);
        }
        setNextButtonO(() => Math.floor(data.offerCount / PER_PAGE));
        if (data.offer == PER_PAGE) {
          setNextButtonO(Math.floor(data.offerCount / PER_PAGE) - 1);
        }
      })
      .catch((e) => { })
  };

  const getLayoutApi = () => {
    getAllEmailTemplatesTheme(PER_PAGE, 0)
      .then((data) => {
        setLayoutTemplate(data);
        setTemplateid(data.id);
      })
      .catch(function (error) {

      });
  };

  const getSystemTemplateApi = (tags) => {
    if (tags) {
      getAllBlogTemplatesTheme(PER_PAGE, 0, tags)
        .then((data) => {
          setSystemTemplate(data);
        })
        .catch(function (error) {

        });
      getAllTemplatesCountByTag(tags).then(data => {
        setNextButtonB(() => Math.floor(data.blogCount / PER_PAGE));
        if (data.blogCount == PER_PAGE) {
          setNextButtonB(Math.floor(data.blogCount / PER_PAGE) - 1);
        }
      })
    } else {
      getAllBlogTemplatesTheme(PER_PAGE, 0)
        .then((data) => {
          setSystemTemplate(data);
        })
        .catch(function (error) {

        });
      getTotalCount();
    }

  };

  const getUserTemplateApi = () => {
    getAllCalculatorTemplatesTheme(PER_PAGE, 0)
      .then((data) => {
        setUserTemplate(data);
      })
      .catch(function (error) {

      });
  };

  const fetchOffers = () => {
    getAllOffers(PER_PAGE, 0)
      .then((data) => {
        setOffers(data);
      })
      .catch(function (error) {

      });
  }

  const getTemplateTagsApi = () => {
    getTemplateTags().then((res) => {
      setBlogTemplateTags(res);
    })
  }

  const getEtype = () => {
    const temp = sessionStorage.getItem("editorType");

    sete_type(temp);
  };

  const setTemplateOnTheURL = (key) => {

    dispatch(setIsContentFlag(true));
    dispatch(setBaseTemplateId(key.template_id));
    dispatch(setTemplateId(key.template_id));
    // dispatch(setTemplateParameterId(null));
    dispatch(setTemplateType(key.template_type));
    props.history.push(`/admin/templates/create`);

    // }
  };
  const setOfferTemplateOnTheURL = (key) => {

    dispatch(setIsContentFlag(true));

    dispatch(setTemplateId(key.template_id));
    // dispatch(setTemplateParameterId(null));
    dispatch(setTemplateType('publishedContent'));
    dispatch(setISOffer(true));
    props.history.push(`/admin/templates/create?flow=offer`);

    // }
  };
  const PreviousDataShowing = async (e) => {
    e.preventDefault();
    getAllCalculatorTemplatesTheme(PER_PAGE, offSet - PER_PAGE)
      .then((data) => {
        setOffSet(() => offSet - PER_PAGE);
        setMatchNextButton(() => matchNextButton - 1);
        setUserTemplate(data);
      })
      .catch((e) => { })
  };
  const NextDataShowing = async (e, data) => {
    e.preventDefault();
    setMatchNextButton(() => matchNextButton + 1);
    getAllCalculatorTemplatesTheme(PER_PAGE, offSet + PER_PAGE)
      .then((data) => {
        setOffSet(() => offSet + PER_PAGE);
        setUserTemplate(data);
      })
      .catch((e) => { })
  };
  const PreviousDataShowingB = async (e) => {
    e.preventDefault();
    getAllBlogTemplatesTheme(PER_PAGE, offSetB - PER_PAGE)
      .then((data) => {
        setOffSetB(() => offSetB - PER_PAGE);
        setMatchNextButtonB(() => matchNextButtonB - 1);
        setSystemTemplate(data);
      })
      .catch((e) => { })
  };
  const NextDataShowingB = async (e, data) => {
    e.preventDefault();
    setMatchNextButtonB(() => matchNextButtonB + 1);
    getAllBlogTemplatesTheme(PER_PAGE, offSetB + PER_PAGE)
      .then((data) => {
        setOffSetB(() => offSetB + PER_PAGE);
        setSystemTemplate(data);
      })
      .catch((e) => { })
  };
  const PreviousDataShowingE = async (e) => {
    e.preventDefault();
    getAllEmailTemplatesTheme(PER_PAGE, offSetE - PER_PAGE)
      .then((data) => {
        setOffSetE(() => offSetE - PER_PAGE);
        setMatchNextButtonE(() => matchNextButtonE - 1);
        setLayoutTemplate(data);
      })
      .catch((e) => { })
  };
  const NextDataShowingE = async (e, data) => {
    e.preventDefault();
    setMatchNextButtonE(() => matchNextButtonE + 1);
    getAllEmailTemplatesTheme(PER_PAGE, offSetE + PER_PAGE)
      .then((data) => {
        setOffSetE(() => offSetE + PER_PAGE);
        setLayoutTemplate(data);
      })
      .catch((e) => { })
  };

  const PreviousDataShowingO = async (e) => {
    e.preventDefault();
    getAllOffers(PER_PAGE, offSetO - PER_PAGE)
      .then((data) => {
        setOffSetO(() => offSetO - PER_PAGE);
        setMatchNextButtonO(() => matchNextButtonO - 1);
        setOffers(data);
      })
      .catch((e) => { })
  };
  const NextDataShowingO = async (e, data) => {
    e.preventDefault();
    setMatchNextButtonO(() => matchNextButtonO + 1);
    getAllOffers(PER_PAGE, offSetO + PER_PAGE)
      .then((data) => {
        setOffSetO(() => offSetO + PER_PAGE);
        setOffers(data);
      })
      .catch((e) => { })
  };
  if(role =='publisher'){
    dispatch(setCurrentTab('blogTab')) 
  }
  function settingTab() {
    if(role =='publisher'){
      dispatch(setCurrentTab('blogTab')) 
    }
    if (currentTab === "emailTab" && emailNavRef.current) {
      emailNavRef.current.classList.add('active');
      emailTabRef.current.classList.add('active');
    } else if (currentTab === "blogTab") {
      blogNavRef.current.classList.add('active');
      blogTabRef.current.classList.add('active');
      getPermissions().then(res => {
        setCheckoutPermission(!res["CheckoutBlogs"].allowed)
        setPermissionMessage(res["CheckoutBlogs"].message)
      })
    } else if (currentTab === "calculatorTab") {
      calculatorNavRef.current.classList.add('active');
      calculatorTabRef.current.classList.add('active');
    } else if (currentTab === "offerTab") {
      offerNavRef.current.classList.add('active');
      offerTabRef.current.classList.add('active');
    }
  }
  useEffect(() => {
    getEtype();
    getTotalCount();
    getLayoutApi();
    getSystemTemplateApi();
    getUserTemplateApi();
    fetchOffers();
    getTemplateTagsApi();
    settingTab()

  }, []);

  const messageBar = (permissionMessage) => {

    if (permissionMessage) {
      return (
        showPermissionMessage && <div ref={permissionMessageRef} style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>
          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }

  return (
    <div className="templates">
      {
        messageBar(permissionMessage)
      }
      <SupportLink link='https://kapitalwise.com/user-guide/content/' />

      <div className="page_heading">
        <h2>Select a Content</h2>
      </div>

      <div className="cmpgn_list_outer">
        <div className="cmpgn_tab_erap">
          <ul className="nav nav-tabs" role="tablist">
            { role !='publisher' && <li className="nav-item">
              <a
                className="nav-link"
                href="#emailThemes"
                role="tab"
                data-toggle="tab"
                ref={emailNavRef}
                onClick={(e) => { dispatch(setCurrentTab('emailTab')) }}
              >
                Email Themes
              </a>
            </li> }
            <li className="nav-item">
              <a
                className="nav-link"
                href="#blogsTab"
                role="tab"
                data-toggle="tab"
                ref={blogNavRef}
                onClick={(e) => {
                  dispatch(setCurrentTab('blogTab'))
                  getPermissions().then(res => {
                    setCheckoutPermission(!res["CheckoutBlogs"].allowed)
                    setPermissionMessage(res["CheckoutBlogs"].message)
                  })
                }}
              >
                Blogs
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#calculatorsTab"
                role="tab"
                data-toggle="tab"
                ref={calculatorNavRef}
                onClick={(e) => { dispatch(setCurrentTab('calculatorTab')) }}
              >
                Calculators
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#offersTab"
                role="tab"
                data-toggle="tab"
                ref={offerNavRef}
                onClick={(e) => { dispatch(setCurrentTab('offerTab')) }}
              >
                Offers
              </a>
            </li>

          </ul>

          <div className="tab-content">
            {/*  Email themes Tab */}
            <div
              role="tabpanel"
              className="tab-pane fade"
              id="emailThemes"
              ref={emailTabRef}
            >
              <div className="template_block">
                {getLayoutTemplate ? (
                  <div>
                    <div className="card_inn_heading mb-4">
                      <h3>Featured</h3>
                      <p className="sm d-flex align-items-center">
                        <span className="inline-label ml-auto">
                          Page No. {matchNextButtonE} of {nextButtonE + 1}
                        </span>
                      </p>
                    </div>
                    <div className="row templates-row">
                      {getLayoutTemplate
                        ? getLayoutTemplate.map((rows) => {
                          const template_type = rows.type;
                          const template_id = rows.id;
                          return (
                            <div className="col-lg-3">
                              <a
                                className="template-card"
                                onClick={() =>
                                  setTemplateOnTheURL({
                                    template_id,
                                    template_type,
                                  })
                                }
                              >
                                {rows.isExclusive ? (
                                  <figure
                                    className="template-img"
                                    style={{ position: "relative" }}
                                  >
                                    <img src={rows.imageUrl} />
                                    <img
                                      style={{
                                        top: "0%",
                                        position: "absolute",
                                        left: "0vw",
                                        width: "140px",
                                        height: "140px",
                                      }}
                                      src={require("assets/img/exclusive.png")}
                                    />
                                  </figure>
                                ) : (
                                  <figure className="template-img">
                                    <img src={rows.imageUrl} />
                                  </figure>
                                )}
                                <figcaption className="template_info text-center">
                                  <h3>{rows.name}</h3>
                                  <p>{rows.description}</p>
                                </figcaption>
                              </a>
                            </div>
                          );
                        })
                        : null}
                    </div>
                    <div className="cstm-table-footer">
                      <ul className="ftr-btn-list">
                        <li>
                          {offSetE == 0 ? (
                            <button
                              type="button"
                              className="table-data-btn btn-prev disabled-btn"
                              style={{
                                cursor: "not-allowed",
                                opacity: "0.6",
                              }}
                            >
                              <ArrowBackIosIcon />
                            </button>
                          ) : (
                            <button
                              onClick={(e) => {
                                PreviousDataShowingE(e, "userTemplate");
                              }}
                              type="button"
                              class="table-data-btn btn-prev"
                            >
                              <ArrowBackIosIcon />
                            </button>
                          )}
                        </li>
                        <li>
                          {nextButtonE >= matchNextButtonE ? (
                            <button
                              onClick={(e) => {
                                NextDataShowingE(e, "userTemplate");
                              }}
                              type="button"
                              class="table-data-btn btn-next"
                            >
                              <ArrowBackIosIcon />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="table-data-btn btn-next disabled-btn"
                              style={{
                                cursor: "not-allowed",
                                opacity: "0.6",
                              }}
                            >
                              <ArrowBackIosIcon />
                            </button>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <ContantLoader />
                )}
              </div>
            </div>

            {/* Blogs Tab */}
            <div role="tabpanel" className="tab-pane fade" id="blogsTab" ref={blogTabRef}>
              {getSystemtTemplate ? (
                <div className="template_block">
                  <div className="card_inn_heading mb-4">
                    <span className="inline-label mr-2">Filter by Tags</span>
                    <select
                      onChange={(e) => {

                        getSystemTemplateApi(e.target.value)
                      }}
                      className="sc-kEYyzF iWaZxR kw_select_tag"
                    // style={{ width: `${styleWidth}px` }}
                    >
                      <option default id="default1" value={""}>
                        Please Select
                      </option>
                      {
                        blogTemplateTags && blogTemplateTags.map((tag) => {
                          return (
                            <option value={tag.tagName}>{tag.tagName}</option>
                          )
                        })
                      }
                    </select>
                    <p className="sm d-flex align-items-center">
                      <span className="inline-label ml-auto">
                        Page No. {matchNextButtonB} of {nextButtonB + 1}
                      </span>
                    </p>
                  </div>

                  <div className="row templates-row">
                    {getSystemtTemplate
                      ? getSystemtTemplate.map((rows) => {
                        const template_id = rows.id;
                        const template_type = rows.type;
                        return (
                          <div className="col-lg-3">
                            <a
                              className="template-card"
                              onClick={(e) =>
                                setTemplateOnTheURL({
                                  template_id,
                                  template_type,
                                })
                              }
                            >
                              {
                                rows.source === 'CentSai' && <input
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    addToCartTemplate(template_id).then(data => {
                                      toast.success("Template added to cart")
                                    }).catch(err => {
                                      return err
                                    })
                                  }}
                                  disabled={rows.isCheckedOut || checkoutPermission ? true : false}
                                  className='lg_btn primary checkout_btn'
                                  type="button"
                                  value={rows.isCheckedOut ? "Added" : "Checkout"}
                                  style={
                                    checkoutPermission ? { position: 'absolute', top: '8px', right: '25px', fontSize: '15px', lineHeight: '15px', zIndex: '1', backgroundColor: '#969FE8', borderColor: '#969FE8', cursor: 'not-allowed' } : { position: 'absolute', top: '8px', right: '25px', fontSize: '15px', lineHeight: '15px', zIndex: '1' }
                                  }
                                />
                              }
                              {rows.isExclusive ? (
                                <figure
                                  className="template-img"
                                  style={{ position: "relative" }}
                                >
                                  <img src={rows.imageUrl} />
                                  <img
                                    style={{
                                      top: "0%",
                                      position: "absolute",
                                      left: "0vw",
                                      width: "140px",
                                      height: "140px",
                                    }}
                                    src={require("assets/img/exclusive.png")}
                                  />
                                </figure>
                              ) : (
                                <figure className="template-img">
                                  <img src={rows.imageUrl} />
                                </figure>
                              )}
                              <figcaption className="template_info text-center">
                                <h3>{rows.name}</h3>
                                <p>{rows.description}</p>
                              </figcaption>
                            </a>
                          </div>
                        );
                      })
                      : ""}
                  </div>
                  <div className="cstm-table-footer">
                    <ul className="ftr-btn-list">
                      <li>
                        {offSetB == 0 ? (
                          <button
                            type="button"
                            className="table-data-btn btn-prev disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            onClick={(e) => {
                              PreviousDataShowingB(e, "userTemplate");
                            }}
                            type="button"
                            class="table-data-btn btn-prev"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                      <li>
                        {nextButtonB >= matchNextButtonB ? (
                          <button
                            onClick={(e) => {
                              NextDataShowingB(e, "userTemplate");
                            }}
                            type="button"
                            class="table-data-btn btn-next"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="table-data-btn btn-next disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                <ContantLoader />
              )}
            </div>

            {/* Calculators Tab */}
            <div role="tabpanel" className="tab-pane fade" id="calculatorsTab" ref={calculatorTabRef}>
              {getUserTemplate ? (
                <div className="template_block">
                  <div className="card_inn_heading mb-4">
                    <h3>Top Calculators</h3>
                    {/* You have {totalCount.calculatorCount} templates. */}
                    <p className="sm d-flex align-items-center">
                      <span className="inline-label ml-auto">
                        Page No. {matchNextButton} of {nextButton + 1}
                      </span>
                    </p>
                  </div>
                  <div className="row templates-row">
                    {getUserTemplate
                      ? getUserTemplate.map((rows) => {
                        const template_id = rows.id;
                        const template_type = rows.type;
                        return (
                          <div className="col-lg-3">
                            <a
                              className="template-card"
                              onClick={() =>
                                setTemplateOnTheURL({
                                  template_id,
                                  template_type,
                                })
                              }
                            >
                              {rows.isExclusive ? (
                                <figure
                                  className="template-img"
                                  style={{ position: "relative" }}
                                >
                                  <img src={rows.imageUrl} />
                                  <img
                                    style={{
                                      top: "0%",
                                      position: "absolute",
                                      left: "0vw",
                                      width: "140px",
                                      height: "140px",
                                    }}
                                    src={require("assets/img/exclusive.png")}
                                  />
                                </figure>
                              ) : (
                                <figure className="template-img">
                                  <img src={rows.imageUrl} />
                                </figure>
                              )}

                              <figcaption className="template_info text-center">
                                <h3>{rows.name}</h3>
                                <p>{rows.description}</p>
                              </figcaption>
                            </a>
                          </div>
                        );
                      })
                      : ""}
                  </div>
                  <div className="cstm-table-footer">
                    <ul className="ftr-btn-list">
                      <li>
                        {offSet == 0 ? (
                          <button
                            type="button"
                            className="table-data-btn btn-prev disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            onClick={(e) => {
                              PreviousDataShowing(e, "userTemplate");
                            }}
                            type="button"
                            class="table-data-btn btn-prev"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                      <li>
                        {nextButton >= matchNextButton ? (
                          <button
                            onClick={(e) => {
                              NextDataShowing(e, "userTemplate");
                            }}
                            type="button"
                            class="table-data-btn btn-next"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="table-data-btn btn-next disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                <ContantLoader />
              )}
            </div>

            {/* Offers Tab */}
            <div role="tabpanel" className="tab-pane fade" id="offersTab" ref={offerTabRef}>
              {getUserTemplate ? (
                <div className="template_block">
                  <div className="card_inn_heading mb-4">
                    <h3>Top Offers</h3>
                    {/* You have {totalCount.calculatorCount} templates. */}
                    <p className="sm d-flex align-items-center">
                      <span className="inline-label ml-auto">
                        Page No. {matchNextButtonO} of {nextButtonO + 1}
                      </span>
                    </p>
                  </div>
                  <div className="row templates-row">
                    {offers
                      ? offers.map((rows) => {
                        const template_id = rows.id;
                        const template_type = rows.type;
                        return (
                          <div className="col-lg-3">
                            <a
                              className="template-card"
                              onClick={() =>
                                setOfferTemplateOnTheURL({
                                  template_id,
                                  template_type,
                                })
                              }
                            >
                              {rows.isExclusive ? (
                                <figure
                                  className="template-img"
                                  style={{ position: "relative" }}
                                >
                                  <img src={rows.imageUrl} />
                                  <img
                                    style={{
                                      top: "0%",
                                      position: "absolute",
                                      left: "0vw",
                                      width: "140px",
                                      height: "140px",
                                    }}
                                    src={require("assets/img/exclusive.png")}
                                  />
                                </figure>
                              ) : (
                                <figure className="template-img">
                                  <img src={rows.imageUrl} />
                                </figure>
                              )}

                              <figcaption className="template_info text-center">
                                <h3>{rows.name}</h3>
                                <p>{rows.description}</p>
                              </figcaption>
                            </a>
                          </div>
                        );
                      })
                      : ""}
                  </div>
                  <div className="cstm-table-footer">
                    <ul className="ftr-btn-list">
                      <li>
                        {offSetO == 0 ? (
                          <button
                            type="button"
                            className="table-data-btn btn-prev disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            onClick={(e) => {
                              PreviousDataShowingO(e, "offer");
                            }}
                            type="button"
                            class="table-data-btn btn-prev"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                      <li>
                        {nextButtonO >= matchNextButtonO ? (
                          <button
                            onClick={(e) => {
                              NextDataShowingO(e, "offer");
                            }}
                            type="button"
                            class="table-data-btn btn-next"
                          >
                            <ArrowBackIosIcon />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="table-data-btn btn-next disabled-btn"
                            style={{
                              cursor: "not-allowed",
                              opacity: "0.6",
                            }}
                          >
                            <ArrowBackIosIcon />
                          </button>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                <ContantLoader />
              )}
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
